import {
  GraphQlClient,
} from '@intelipost-js/secure-providers';
import {
  ScToast,
} from '@intelipost-js/secure-components';

export default {
  getOrder({ commit }, params) {
    const {
      order_number,
      volume_id,
    } = params;
    commit('toggleLoading', true);
    return GraphQlClient.query(`
      query (
        $order_number: String!
      ){
        order(order_number: $order_number) {
          order_number,
          is_reverse,
          volumes{
            tracking_code,
            id
          }
          end_customer{
            name
          }
          warehouse {
            name
          }
          logistic_provider{
            delivery_method{
              name
            }
          }
        }
      }`, { order_number })
      .then((res) => {
        const { data = {} } = res || {};
        const { order = {} } = data || {};
        const volume = order.volumes
          .find(vol => vol.id === volume_id);
        const orderTransformed = Object.assign(order, { volume });
        commit('setOrder', orderTransformed);
        commit('toggleLoading', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },

  getInformationOrders({ commit }, params) {
    const {
      route_params,
      router,
    } = params;

    const {
      volume_id,
    } = route_params;

    commit('toggleLoading', true);
    return GraphQlClient.query(`
    query (
      $volume_id: String!,
    ) {
      refund(
        volume_id: $volume_id,
      ) {
           status,
           date,
          value,
          information_order {
            number,
            opening_reason,
            solicitation_date,
            status,
            substatus,
            message,
            response_time,
            messages {
              date,
              event,
              observation,
            }
          }
          order {
            invalid_zip_code
          }
        }
      }`, { volume_id })
      .then((res) => {
        const { data = {} } = res || {};
        const { refund = {} } = data || {};
        commit('setRefund', refund);
        commit('toggleLoading', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        router.push({
          name: 'dashboard',
        });
        return Promise.reject(err);
      });
  },
  openInformationOrder({ commit }, params) {
    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $reason_opening: Int,
      $message: String!,
      $volume_id: String!,
    ) {
      openingManifestation(
        reason_opening: $reason_opening,
        message: $message,
        volume_id: $volume_id
      ) {
        order{
          volumes{
            id
          }
        }
      }
    }`, params)
      .then((res) => {
        ScToast.success('Solicitação de Pedido de informação feito com sucesso.');
        commit('toggleLoading', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  openManifestation({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
    mutation (
      $message: String!,
      $volume_id: String!,
    ) {
      openingManifestation(
        message: $message,
        volume_id: $volume_id
      ) {
        order{
          volumes{
            id
          }
        }
      }
    }`, params)
      .then((res) => {
        ScToast.success('Manifestação enviaada com sucesso.');
        commit('toggleLoading', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-refund/features/information-order/store/actions.js